const state = {
  articles: [],
  dimension: [],
  counthighlight: null,
  article_id: [],
  Adminhub: [],
  PackageSize: [],
  Itemtype: [],
  Addon: [],
  ExtraPackaging: [],
};

export default state;
